export const GLOBAL_EVENTS_RESET_STATE = 'GLOBAL_EVENTS_RESET_STATE';
export const GLOBAL_EVENTS_CURRENT_ITEM = 'GLOBAL_EVENTS_CURRENT_ITEM';

export const GLOBAL_EVENTS_REQUEST_LOADING = 'GLOBAL_EVENTS_REQUEST_LOADING';
export const GLOBAL_EVENTS_REQUEST_SUCCESS = 'GLOBAL_EVENTS_REQUEST_SUCCESS';
export const GLOBAL_EVENTS_REQUEST_FAILED = 'GLOBAL_EVENTS_REQUEST_FAILED';

export const GLOBAL_EVENTS_CURRENT_ACTION = 'GLOBAL_EVENTS_CURRENT_ACTION';
export const GLOBAL_EVENTS_RESET_ACTION = 'GLOBAL_EVENTS_RESET_ACTION';
